import { render, staticRenderFns } from "./kunden-name-popover.vue?vue&type=template&id=32deae8b&scoped=true"
import script from "./kunden-name-popover.vue?vue&type=script&lang=js"
export * from "./kunden-name-popover.vue?vue&type=script&lang=js"
import style1 from "./kunden-name-popover.vue?vue&type=style&index=1&id=32deae8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32deae8b",
  null
  
)

export default component.exports